module.exports = __webpack_public_path__ + "static/media/sportnews-banner.7fd409e4.svg";